import { timelineEpochMs } from './stormClock.js';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// All timeline text is read in UTC so it agrees with the trajectory labels regardless of the viewer's timezone.
export const formatTimeDisplayUtc = (date, separator = '·') => {
  const hours = String(date.getUTCHours()).padStart(2, '0');
  return `${DAYS[date.getUTCDay()]} ${date.getUTCDate()} ${separator} ${hours}:00`;
};

/**
 * The same readout split into its parts.
 *
 * The map's timeline sets the date and the time in different weights — the
 * date is what you are reading, the hour is context — which one joined string
 * cannot express. The home strip still uses the joined form above, so both
 * stay driven by the same day names and UTC handling.
 */
export const formatTimelinePartsUtc = (date) => ({
  day: `${DAYS[date.getUTCDay()]} ${date.getUTCDate()}`,
  time: `${String(date.getUTCHours()).padStart(2, '0')}:00`,
});

export const generateDayMarkers = (startDate, numDays = 10) => {
  const markers = [];
  for (let i = 0; i <= numDays; i++) {
    const d = new Date(timelineEpochMs(startDate, i * 24));
    markers.push({
      index: i,
      hour: i * 24,
      label: `${DAYS[d.getUTCDay()]} ${d.getUTCDate()}`,
      isToday: i === 0,
    });
  }
  return markers;
};
